if (!customElements.get('bh-sova-growth')) {
  customElements.define('bh-sova-growth', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.button = this.querySelector('[data-bh-growth-toggle]');
      this.white = this.querySelector('[data-bh-growth-white]');
      this.natural = this.querySelector('[data-bh-growth-natural]');
      this.steps = [...this.querySelectorAll('[data-bh-growth-step]')];
      this.animation = this.querySelector('[data-bh-growth-animation]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.stage = -1;
      this.button.hidden = false;
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.updatePlayback(); }, { signal: this.abort.signal });
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.updatePlayback(); }, { signal: this.abort.signal });
      document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal: this.abort.signal });
      document.addEventListener('variant:change', event => {
        const formId = event.target?.getAttribute?.('id') || '';
        if (!formId.startsWith('product-form-main-' + this.dataset.productId + '-')) return;
        const title = event.detail?.variant?.title;
        if (!title) return;
        this.dataset.finish = title.toLowerCase();
        this.querySelector('[data-bh-growth-finish]').textContent = title;
        this.white.hidden = this.dataset.finish !== 'white';
        this.natural.hidden = this.dataset.finish === 'white';
        this.stage = -1;
        this.updatePlayback();
      }, { signal: this.abort.signal });
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.updatePlayback();
      }, { threshold: 0.08 });
      this.observer.observe(this);
      this.updatePlayback();
    }
    updatePlayback() {
      clearTimeout(this.timer);
      const playing = !this.paused && this.inView && !document.hidden;
      this.classList.toggle('is-playing', playing);
      this.dataset.playing = String(Boolean(playing));
      this.button.textContent = this.paused ? 'Play animation' : 'Pause animation';
      this.button.setAttribute('aria-pressed', String(this.paused));
      const animateGif = playing && this.dataset.finish !== 'white';
      const src = animateGif ? this.animation.dataset.bhGrowthAnimation : this.animation.dataset.bhGrowthPoster;
      if (this.animation.getAttribute('src') !== src) this.animation.src = src;
      if (playing && this.dataset.finish === 'white') this.tick();
      else this.steps.forEach(step => { step.classList.add('is-revealed'); step.classList.remove('is-current'); });
    }
    tick() {
      this.stage = (this.stage + 1) % 6;
      this.dataset.activeStep = String(this.stage);
      this.steps.forEach((step, index) => {
        step.classList.toggle('is-revealed', index <= this.stage);
        step.classList.toggle('is-current', index === this.stage);
      });
      this.timer = setTimeout(() => this.tick(), this.stage === 5 ? 3000 : 1100);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.abort?.abort(); }
  });
}
